/* Renaissance Afro — motion design. Léger, sans dépendance, désactivable dans Réglages du thème → Renaissance Afro. */
(function () {
  'use strict';
  var html = document.documentElement;
  var cfg = window.RA_MOTION || {};
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!cfg.enabled || reduce) { html.classList.remove('ra-motion'); return; }

  /* 1. Révélation au scroll, avec décalage progressif entre éléments voisins */
  var targets = [
    '.ra-hero__copy > *', '.ra-hero__media', '.ra-values span',
    '.ra-story__media', '.ra-story__copy > *', '.ra-ritual__head > *', '.ra-step',
    '.ra-help > *', '.ra-collection-heading > *', '.ra-faq__head > *', '.ra-faq details',
    '.product-list .product-card', '.product-grid .product-card', '.product-list__header > *',
    '.ra-footer__identity > *', '.ra-footer nav', '.comparison-slider', '.section-content-wrapper > *'
  ];
  var els = document.querySelectorAll(targets.join(','));
  var groups = new Map();
  els.forEach(function (el) {
    if (el.closest('.ra-reveal')) return;        /* pas d'imbrication */
    el.classList.add('ra-reveal');
    var parent = el.parentElement;
    var i = groups.get(parent) || 0;
    el.style.setProperty('--ra-i', i);
    groups.set(parent, i + 1);
  });
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('ra-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ra-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9) { el.classList.add('ra-in'); } else { io.observe(el); }
    });
  }

  /* 2. Parallaxe douce sur la photo du hero et de l'histoire */
  if (cfg.parallax) {
    var layers = document.querySelectorAll('.ra-hero__media img, .ra-story__media img');
    var ticking = false;
    var update = function () {
      ticking = false;
      var vh = window.innerHeight;
      layers.forEach(function (img) {
        var box = img.parentElement.getBoundingClientRect();
        if (box.bottom < 0 || box.top > vh) return;
        var p = (box.top + box.height / 2 - vh / 2) / vh;   /* -1 … 1 */
        img.style.transform = 'scale(1.08) translate3d(0,' + (p * -4).toFixed(2) + '%,0)';
      });
    };
    var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* 3. Bandeau de valeurs qui défile en continu (pause au survol) */
  if (cfg.marquee) {
    document.querySelectorAll('.ra-values').forEach(function (bar) {
      if (bar.dataset.raMarquee) return;
      bar.dataset.raMarquee = '1';
      var items = Array.prototype.slice.call(bar.children);
      var track = document.createElement('div');
      track.className = 'ra-values__track';
      var copies = Math.max(2, Math.ceil((window.innerWidth * 2) / Math.max(1, bar.scrollWidth)) + 1);
      if (copies % 2) copies++;
      for (var c = 0; c < copies; c++) {
        items.forEach(function (it) {
          var cl = it.cloneNode(true);
          if (c > 0) cl.setAttribute('aria-hidden', 'true');
          cl.classList.remove('ra-reveal'); cl.classList.add('ra-in');
          track.appendChild(cl);
        });
      }
      bar.innerHTML = ''; bar.appendChild(track); bar.classList.add('ra-values--marquee');
    });
  }

  /* 4. Léger effet "magnétique" sur les boutons principaux */
  if (cfg.magnetic && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.querySelectorAll('.ra-button, .button, .button-secondary').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) / r.width;
        var y = (e.clientY - r.top - r.height / 2) / r.height;
        btn.style.transform = 'translate(' + (x * 6).toFixed(1) + 'px,' + (y * 6).toFixed(1) + 'px)';
      });
      btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }

  /* 5. Compteur de chiffres (data-ra-count="250") pour de futurs blocs chiffres clés */
  document.querySelectorAll('[data-ra-count]').forEach(function (el) {
    var end = parseFloat(el.getAttribute('data-ra-count')) || 0, dur = 1200, t0 = null;
    var step = function (t) {
      if (!t0) t0 = t; var k = Math.min(1, (t - t0) / dur); k = 1 - Math.pow(1 - k, 3);
      el.textContent = Math.round(end * k).toLocaleString('fr-FR');
      if (k < 1) requestAnimationFrame(step);
    };
    new IntersectionObserver(function (en, o) { if (en[0].isIntersecting) { requestAnimationFrame(step); o.disconnect(); } }).observe(el);
  });
})();
